import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import LocationServices from '../../services/LocationServices';

function LocationUpdate({ location, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    cityName: '',
    pincode: '',

  });
  

  useEffect(() => {
    if (location) {
      setFormValues({
        cityName: location?.cityName || '',
        pincode: location?.pincode || '',
       
    
      });
    
    }
  }, [location]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

 

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
    

      await LocationServices.updateLocation(location.id, formValues);
      alert('Location updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update location', error);
      alert('Failed to update location');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Location</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="input-field">
                          <label>City Name</label>
                          <input type="text" name="cityName" className="form-control" value={formValues.cityName} onChange={handleInputChange} placeholder="City Name" required />
                        </div>
                      </div>
                      <div className="col-lg-13 col-sm-12">
                        <div className="input-field">
                          <label>Pincode</label>
                          <input type="text" name="pincode" className="form-control" value={formValues.pincode} onChange={handleInputChange} placeholder="Pincode" required />
                        </div>
                      </div>
      
                     
                     
                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationUpdate;
